import React from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { Countdown } from '../Countdown';
import { CtaButton } from '../CtaButton';
export function SecondUrgency() {
  return <section className="bg-crema-alt py-16 sm:py-20 px-5" data-id="element-236" data-mp="74j7xsz0fl9r">
      <div className="max-w-4xl mx-auto rounded-3xl bg-white border border-coral/30 shadow-sm p-7 sm:p-10 grid gap-8 md:grid-cols-[1.3fr_1fr] md:items-center" data-id="element-237" data-mp="752nj316txkm">
        <div data-id="element-238" data-mp="ztqf1gcj5j6m">
          <span className="inline-flex items-center gap-2 text-coral font-semibold text-sm uppercase tracking-widest" data-id="element-239" data-mp="zs5k3pmazy88">
            <AlarmClockIcon className="w-4 h-4" aria-hidden="true" data-id="element-240" data-mp="uun81qczp2w0" />
            La letra no se arregla sola
          </span>
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl font-bold text-violeta leading-tight" data-id="element-241" data-mp="pwviv43qbuvi">
            Cada año que pasa cuesta más desarmarlo
          </h2>
          <p className="mt-4 text-lg text-tinta/80 leading-relaxed" data-id="element-242" data-mp="3am1gy3qiqybr">
            El movimiento se automatiza: cuanto más tiempo escribe así, más grabado queda. A los 7
            años son tres semanas. A los 11, bastante más.
          </p>
        </div>

        <div className="text-center" data-id="element-243" data-mp="5xfht04bdssj">
          <p className="text-sm uppercase tracking-widest text-tinta/55" data-id="element-244" data-mp="5wcv74e0ycif">
            El precio de lanzamiento termina en
          </p>
          <Countdown className="mt-4" tone="light" data-id="element-245" data-mp="3o5n36gl0sqzz" />
          <CtaButton action="scroll" size="md" className="mt-6 w-full" data-id="element-246" data-mp="3s3unflep0afx">
            EMPEZAR HOY
          </CtaButton>
        </div>
      </div>
    </section>;
}